import Vue from 'vue'
import MentorChats from 'mentor-chats.vue'
import store from 'check-store.js'

document.addEventListener('DOMContentLoaded', () => {
  const selector = '#js-mentor-chats'
  const mentorComments = document.querySelector(selector)
  if (mentorComments) {
    const mentorCommentableId = mentorComments.getAttribute('data-mentor-commentable-id')
    const mentorCommentableType = mentorComments.getAttribute('data-mentor-commentable-type')
    const currentUserId = Number(mentorComments.getAttribute('data-current-user-id'))
    const currentUser = window.currentUser
    // WebSocketを再開する場合に戻す（doc/architecture.md §5.6）
    // const broadcastName = mentorComments.getAttribute('data-broadcast-name')
    const filterOptions = mentorComments.getAttribute('data-filter-options')
    new Vue({
      store,
      render: (h) =>
        h(MentorChats, {
          props: {
            mentorCommentableId: mentorCommentableId,
            mentorCommentableType: mentorCommentableType,
            currentUserId: currentUserId,
            currentUser: currentUser,
            // broadcastName: broadcastName,
            filterOptions: filterOptions,
          }
        })
    }).$mount(selector)
  }
})
